"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = require("prop-types");
var _scriptConstants = _interopRequireDefault(require("../../configs/scriptConstants"));
function ChatBot(_ref) {
  var config = _ref.config;
  var onScriptLoad = function onScriptLoad() {
    window.F9.Chat.Wrapper.init(config);
  };
  var initChatBot = function initChatBot() {
    var script = document.createElement('script');
    script.src = _scriptConstants.default.url;
    script.id = 'chat-bot-script';
    script.onload = onScriptLoad;
    document.body.appendChild(script);
  };
  (0, _react.useEffect)(function () {
    initChatBot();
  }, []);
  return null;
}
var _default = ChatBot;
exports.default = _default;
ChatBot.propTypes = {
  config: (0, _propTypes.shape)({
    cdn: _propTypes.string,
    useBusinessHours: _propTypes.bool,
    languages: (0, _propTypes.shape)({
      enabled: _propTypes.bool,
      backgroundColor: _propTypes.string
    }),
    l10n: (0, _propTypes.shape)({
      en: (0, _propTypes.shape)({
        messenger: (0, _propTypes.shape)({
          customText: (0, _propTypes.shape)({})
        }),
        systemMessages: (0, _propTypes.shape)({
          transferredToParticipant: _propTypes.string,
          transferredToGroup: _propTypes.string
        }),
        captureFields: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
          k: _propTypes.string,
          l: _propTypes.string,
          p: _propTypes.string
        }))
      })
    }),
    prepopulatedFields: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      k: _propTypes.string,
      v: _propTypes.string
    })),
    messenger: (0, _propTypes.shape)({
      integrationId: _propTypes.string,
      soundNotificationEnabled: _propTypes.bool,
      transcriptPrintingEnabled: _propTypes.bool,
      menuItems: (0, _propTypes.shape)({
        imageUpload: _propTypes.bool,
        fileUpload: _propTypes.bool,
        shareLocation: _propTypes.bool
      }),
      embedded: _propTypes.bool,
      businessName: _propTypes.string,
      businessIconUrl: _propTypes.string,
      buttonIconUrl: _propTypes.string,
      browserStorage: _propTypes.string,
      fixedHeader: _propTypes.bool,
      displayStyle: _propTypes.string,
      customColors: (0, _propTypes.shape)({
        brandColor: _propTypes.string,
        conversationColor: _propTypes.string,
        actionColor: _propTypes.string
      })
    }),
    clearMessagesTimeout: _propTypes.number
  })
};
ChatBot.defaultProps = {
  config: {}
};
